<template>
  <div
  class="operation"
  v-loading="isLoading"
  :style="{
     height: currentValue.isShowMore?'auto':'100px',
  }"
   :class="{isShowMore: currentValue.isShowMore}">
     <div class="operation_title">
       <div class="tips">{{item.label}}</div>
        <div class="title" v-html="item.name || '&nbsp;'"></div>
        <div class="status">
            <!-- <img src="../../../assets/image/learnmodel/status1.png" alt="">
            待完成 -->
        </div>
        <div class="btn" @click="handleGoStudy(item)">
            去实操
        </div>
    </div>
    <div class="isShowbtn">
      <div
        class="btn"
        v-show="!currentValue.isShowMore"
        @click="currentValue.isShowMore = true"
        type="info"
        size="mini"
      >
        展开
      </div>
      <div
       class="btn"
        v-show="currentValue.isShowMore"
        @click="currentValue.isShowMore = false"
        type="info"
        size="mini"
      >
        收起
      </div>
    </div>
    <div class="editorShowArea ql-editor" v-html="currentValue.questionContent"></div>
  </div>
</template>

<script>
import * as api from "../../api/courseApi";
export default {
  name: "operation.vue",
  props: {
    questionId: {
      type: [String, Number],
      default: "",
    },
    questionTypeId: {
      type: [String, Number],
      default: "",
    },
    item:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      currentValue: {},
      isLoading: false,
    };
  },
  created() {
    if (this.questionId) {
      this.getMaterial(this.questionId);
    }
  },
  methods: {
    //试题详情
    getMaterial(id) {
      api.getAnswer(id).then((res) => {
        if (res.code === "0") {
          this.$emit('addEventObj',res.data.event[0])
          if (res.data.questions) {
            this.currentValue = res.data.questions;
            this.$set(this.currentValue, "isShowMore", false);
          } else {
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
          return this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    handleGoStudy(item){
      this.$emit('handleGoStudy',item)
    }
  },
};
</script>

<style scoped lang="scss">
.operation {
  width: 100%;
  position: relative;
  padding-bottom: 20px;
  overflow: hidden;
  box-sizing: border-box;
  background:rgba(0, 124, 237, 0.06);
  .operation_title{
        height: 60px;
        line-height: 60px;
        border-bottom: 2px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tips{
          position:absolute;
          left:0;
          top:0;
          width: 68px;
          height: 18px;
          line-height: 18px;
          background: #FECB00;
          border-radius: 0px 0px 10px 10px;
          font-size:12px;
          color: #333;
          text-align: center;
        }
        .title{
            min-width: 200px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #007CED;
            line-height: 60px;
            text-indent: 70px;
            &>p{
              color: #007CED!important;
            }
        }
        .status{
            img{
                width:22px;
                height:22px;
                margin-right:22px;
            }
            display: flex;
            align-items: center;
            // margin-left:200px;
            font-size: 12px;
            color: #333333;
        }
        .btn{
            width: 73px;
            height: 30px;
            line-height: 30px;
            margin-right: 30px;
            text-align: center;
            border-radius: 2px;
            border: 1px solid #007DFF;
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #007FFF;
            text-decoration: none;
            cursor: pointer;
        }
    }
  .btn{
    font-size: 12px;
    color: #007FFF;
    text-decoration: underline;
    cursor: pointer;
  }
  .isShowbtn {
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
  /deep/ .ql-editor{
    height:auto;
  }
  .editorShowArea {
    min-height: calc(100% - 62px);
    // border: 1px solid #e2e2e2;
    overflow: auto;
    text-align: justify;
    padding-left:70px;
    /deep/ img {
      max-width: 100%;
    }
    /deep/ p {
      word-break: break-word;
      font-size: 12px;
      color: #999999;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/component/operation.vue